import { serieId } from './series';
import type { Favorito, ISODateTime, SerieRef } from './types';

/** Tope de favoritos que acepta el servidor (docs/CONTRATO_API.md §2.4). */
export const MAX_FAVORITOS_SERVIDOR = 200;

/** Id estable de un favorito: `rubro|categoria|presentacion|region|fuente` (vacío si no aplica). */
export const favoritoId = (ref: SerieRef): string =>
  `${serieId(ref)}|${ref.region ?? ''}|${ref.fuente ?? ''}`;

export function favoritoDe(ref: SerieRef, creado: ISODateTime): Favorito {
  return {
    id: favoritoId(ref),
    rubro: ref.rubro,
    categoria: ref.categoria,
    presentacion: ref.presentacion,
    region: ref.region ?? null,
    fuente: ref.fuente ?? null,
    creado,
  };
}

/**
 * Une dos listas de favoritos sin repetir ids. Conserva el orden (primero `base`, luego lo nuevo de `extra`)
 * y, si un id está en ambas, la fecha de creación más antigua. Se corta en `max`.
 */
export function mezclarFavoritos(
  base: readonly Favorito[],
  extra: readonly Favorito[],
  max = MAX_FAVORITOS_SERVIDOR,
): Favorito[] {
  const porId = new Map<string, Favorito>();
  for (const f of [...base, ...extra]) {
    const previo = porId.get(f.id);
    if (!previo) porId.set(f.id, f);
    else if (f.creado < previo.creado) porId.set(f.id, { ...previo, creado: f.creado });
  }
  return [...porId.values()].slice(0, max);
}
